import React from 'react';

import {observer} from 'mobx-react';
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {OddsViewModel} from "../../../../domain/common/odds/models/odds.view-model";
import styles from "./game-card-odds.module.scss";
import classnames from "classnames";
import {
  GamesSliderWidgetGameViewModel
} from "../../../../widgets/games-slider-widget/models/games-slider-widget.game-view-model";
import {GameCardOddsCellUsLayout} from "./game-card-odds-cell/game-card.odds-cell.us-layout";
import {OddsCellViewModel} from "../../../../domain/common/odds-preview/models/odds-cell/odds-cell.view-model";
import {TextualOdds} from "../../textual-odds/textual-odds";
import {GameCardOddsCells} from "./game-card.odds-cells";
import {useBookieClick} from "../../../../infrastructure/hooks/useBookieClick";
import {APP} from "../../../app/consts";
import {PartialGameViewModel} from "../../../../domain/partial-game/models/partial-game-view-model";

export class GameCardOddsProps extends BaseProps {
  game: GamesSliderWidgetGameViewModel;
  gameOddsIsSmallView: Boolean;
  odds: OddsViewModel;
  disableTooltip: Boolean;
}

export const GameCardOdds = observer(({
                                        game,
                                        source,
                                        controller,
                                        widgetName,
                                        className,
                                        cellClassName,
                                        gameOddsIsSmallView,
                                        disableTooltip,
                                        showOdds,
                                        textualOddsClassName,
                                        highlightOdds
                                      }: GameCardOddsProps) => {
  const {state} = controller;
  const {currentLinkModel, appSettings} = state;
  const {odds, hasOdds, hasCurrentValidRates, oddsPreview} = game;
  const {small_view, wrapper, us_layout} = styles;

  const {bookieHrefModel, onBookieClick} = useBookieClick(controller, {
    urlLink: appSettings.publisherSettings.bookmakerUrl || odds?.link || odds?.bookmaker?.link,
    currentLinkModelName: currentLinkModel?.name,
    entityType: APP.ANALYTICS.ENTITY_DISPLAY_TYPES[PartialGameViewModel.name],
    entityId: game.id,
    status: game.statusGroup,
    marketType: odds?.lineTypeId,
    bookieId: odds?.bookmaker?.id,
    bookieName: odds?.bookmaker?.name,
    widget: widgetName,
    impressionType: APP.ANALYTICS.BETS_IMPRESSION_TYPES.odds,
    hasOdds: true,
    source
  });

  const betsImpressionParams = {
    bookieId: odds?.bookmaker?.id,
    bookieName: odds?.bookmaker?.name,
    sportTypeId: game.sportId || game.sport?.id
  }

  const shouldRender = showOdds && (game.bettingOpportunity || (!game.bettingOpportunity && hasOdds && (oddsPreview?.cellsRates?.length > 0 || (hasCurrentValidRates && odds))));

  if (!shouldRender) {
    return null;
  }

  const textualOddsProps = {
    controller,
    bookieHrefModel,
    bookieClickEvent: onBookieClick,
    bettingOpportunity: game.bettingOpportunity,
    className: textualOddsClassName
  }

  const isUsLayout: Boolean = oddsPreview?.cellsRates?.length > 0;

  const contentProps = {
    className: classnames(
      {[small_view]: gameOddsIsSmallView},
      wrapper,
      {[us_layout]: isUsLayout},
      className,
      {[styles.block_bookie_links]: !bookieHrefModel}
    ),
  };

  cellClassName = classnames(cellClassName, styles.cell);

  const gameCardOddsCellProps = {
    game,
    source,
    controller,
    bookmaker: odds?.bookmaker,
    betsImpressionParams,
    disableTooltip,
    cellClassName,
    highlightOdds
  }

  const usLayoutCellProps = {
    controller,
    source,
    currentLinkModel,
    appSettings,
    cellClassName,
    game
  }

  return (
    game?.bettingOpportunity ? <TextualOdds {...textualOddsProps}/> : <div {...contentProps}>
      {
        oddsPreview?.cellsRates?.length > 0 ?
          oddsPreview?.cellsRates?.map((cell: OddsCellViewModel, index: Number) => <GameCardOddsCellUsLayout cell={cell}
                                                                                                             key={index} {...usLayoutCellProps}/>) :
          <GameCardOddsCells {...gameCardOddsCellProps}/>
      }
    </div>
  )
});
